import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Container,
  Button,
  useTheme,
} from '@mui/material';
import { People as PeopleIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const TalentPoolSection: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <PeopleIcon 
          sx={{ 
            fontSize: 80, 
            color: theme.palette.primary.main,
            mb: 2,
            opacity: 0.7
          }} 
        />
        <Typography 
          variant="h3" 
          component="h1" 
          gutterBottom
          sx={{
            fontWeight: 'bold',
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 2
          }}
        >
          Talent Pool
        </Typography>
        <Typography 
          variant="h5" 
          color="text.secondary"
          sx={{ mb: 4, maxWidth: 600, mx: 'auto' }}
        >
          Discover and manage talented professionals for your company
        </Typography>
      </Box>

      <Card 
        sx={{ 
          maxWidth: 600, 
          mx: 'auto',
          background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[50]} 100%)`,
          border: `2px solid ${theme.palette.primary.light}`,
          borderRadius: 3,
          boxShadow: `0 8px 32px ${theme.palette.primary.light}20`
        }}
      >
        <CardContent sx={{ p: 6, textAlign: 'center' }}>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 80,
              height: 80,
              borderRadius: '50%',
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
              mb: 3,
              '@keyframes pulse': {
                '0%': {
                  transform: 'scale(1)',
                  opacity: 1,
                },
                '50%': {
                  transform: 'scale(1.05)',
                  opacity: 0.8,
                },
                '100%': {
                  transform: 'scale(1)',
                  opacity: 1,
                },
              },
              animation: 'pulse 2s infinite',
            }}
          >
            <Typography 
              variant="h4" 
              sx={{ 
                color: 'white',
                fontWeight: 'bold'
              }}
            >
              🚀
            </Typography>
          </Box>
          
          <Typography 
            variant="h4" 
            component="h2"
            sx={{ 
              fontWeight: 'bold',
              color: theme.palette.primary.main,
              mb: 2
            }}
          >
            Coming Soon!
          </Typography>
          
          <Typography 
            variant="body1" 
            color="text.secondary"
            sx={{ 
              fontSize: '1.1rem',
              lineHeight: 1.6,
              mb: 3
            }}
          >
            We're working hard to bring you an amazing talent pool experience. 
            This feature will help you discover, connect with, and manage talented 
            professionals for your company.
          </Typography>

          <Button
            variant="contained"
            size="large"
            sx={{ px: 4, py: 1.5, mt: 1 }}
            onClick={() => navigate('/talent-pool')}
          >
            Open Talent Pool
          </Button>

          <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: 2,
              flexWrap: 'wrap',
              mt: 4
            }}
          >
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                px: 2,
                py: 1,
                borderRadius: 2,
                background: theme.palette.primary.light + '20',
                border: `1px solid ${theme.palette.primary.light}`
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                ✨ Smart Matching
              </Typography>
            </Box>
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                px: 2,
                py: 1,
                borderRadius: 2,
                background: theme.palette.secondary.light + '20',
                border: `1px solid ${theme.palette.secondary.light}`
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                🎯 Talent Discovery
              </Typography>
            </Box>
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                px: 2,
                py: 1,
                borderRadius: 2,
                background: theme.palette.success.light + '20',
                border: `1px solid ${theme.palette.success.light}`
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                📊 Analytics
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>

    </Container>
  );
};

export default TalentPoolSection;
